import React, { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import { toast } from 'react-toastify';
import api from '../../config/axios';
import Breadcrumb from '../common/breadcrumb';
import { time } from '../../utils/date';
import { Plus, Truck } from 'react-feather';
import EnvioItem from './envio-item';

// Estado operativo: última transacción de ciclo de vida,
// ignorando 'Pago Confirmado' (no cambia el estado operativo)
const estadoEnvio = (transactions) => {
    if (!transactions || transactions.length === 0) return null;
    const ciclo = transactions.filter((t) => t.name !== 'Pago Confirmado');
    const ordenadas = (ciclo.length ? ciclo : transactions).sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    );
    return ordenadas[ordenadas.length - 1].name;
};

const pagoConfirmado = (transactions) =>
    (transactions || []).some((t) => t.name === 'Pago Confirmado');

const ESTADO_BADGE = {
    'Pedido Creado': 'badge-warning',
    'Pedido Enviado': 'badge-info',
    'Pedido Entregado': 'badge-success',
    'Pedido Cancelado': 'badge-danger',
};

const ESTADO_LABEL = {
    'Pedido Creado': 'Por enviar',
    'Pedido Enviado': 'Enviado',
    'Pedido Entregado': 'Entregado',
    'Pedido Cancelado': 'Cancelado',
};

const renderBadge = (estado) => {
    const cls = ESTADO_BADGE[estado];
    if (!cls) return null;
    return <span className={`badge ${cls}`}>{ESTADO_LABEL[estado]}</span>;
};

// Adaptar cada envío al formato que EnvioItem espera
const parseToDatatable = (envios) =>
    envios.map((envio) => {
        const estado = estadoEnvio(envio.transactions);
        return {
            id: envio.id,
            estado: renderBadge(estado),
            pagado: pagoConfirmado(envio.transactions),
            hora: time(envio.createdAt),
            business: envio.business,
            businessName: envio.businessName,
            receiverName: envio.receiverName,
            receiverStreet1: envio.receiverStreet1,
            receiverStreet2: envio.receiverStreet2,
            zona: envio.zona,
            tarifaEnvio: envio.tarifaEnvio,
            formaPago: envio.paymentMethod ? envio.paymentMethod.name : '-',
            user: envio.user,
        };
    });

const columnsDataTable = (count) => [
    {
        Header: <b>{`${count} envíos`}</b>,
        id: 'envio',
        accessor: () => 'envio',
        Cell: (row) => <EnvioItem data={row.original} />,
        style: { textAlign: 'center', width: '100%' },
        sortable: false,
        width: '100%',
    },
];

const AllEnvios = ({ history }) => {
    const [envios, setEnvios] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchEnvios();
    }, []);

    const fetchEnvios = async () => {
        try {
            const { data } = await api.get('/deliveryOrders');
            const parsed = parseToDatatable(data.data || []);
            setEnvios(parsed);
        } catch (err) {
            toast.error('Error al cargar los envíos');
        } finally {
            setLoading(false);
        }
    };

    const columns = columnsDataTable(envios.length);

    return (
        <Fragment>
            <Breadcrumb title="Envíos" />
            <div className="container-fluid rents-wrapper">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="d-flex justify-content-between align-items-center pt-2 pb-2">
                            <div>
                                <Link
                                    to={`${process.env.PUBLIC_URL}/envios/nuevo-envio`}
                                    className="btn btn-primary"
                                >
                                    <Plus size={16} className="mr-1" />
                                    Nuevo envío
                                </Link>
                            </div>
                            <div>
                                <button
                                    className="btn btn-success"
                                    onClick={fetchEnvios}
                                >
                                    <i className="fa fa-refresh"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                {loading ? (
                                    <div className="text-center py-5">
                                        <div
                                            className="spinner-border text-primary"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Cargando...
                                            </span>
                                        </div>
                                    </div>
                                ) : envios.length === 0 ? (
                                    <div className="text-center py-5">
                                        <Truck
                                            size={48}
                                            style={{ color: '#ccc' }}
                                        />
                                        <p
                                            style={{
                                                fontSize: 18,
                                                color: '#777',
                                                marginTop: 10,
                                            }}
                                        >
                                            No hay envíos registrados
                                        </p>
                                    </div>
                                ) : (
                                    <div
                                        id="basicScenario"
                                        className="order-list"
                                    >
                                        <ReactTable
                                            columns={columns}
                                            className="-striped"
                                            multiSelectOption={false}
                                            data={envios}
                                            defaultPageSize={10}
                                            showPageSizeOptions={false}
                                            nextText="Siguiente"
                                            previousText="Anterior"
                                            getTrProps={(state, rowInfo) => ({
                                                onClick: () =>
                                                    history.push(
                                                        `/envios/detalle/${rowInfo.original.id}`,
                                                    ),
                                            })}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default AllEnvios;